/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Button } from "@/components/ui/Button";
import CustomModal from "@/components/ui/CustomModal";
import PDFViewer from "@/components/ui/PDFViewer";
import { IGrammarExercise, IScoreBar, IUserAnswers } from "@/types";
import { generatePDF } from "@/utils/pdf-generator";
import Spinner from "@edusogno/primitives/spinner.js";
import { uniqBy } from "lodash";
import { FC, useEffect, useState } from "react";

interface PotExerciseResultModalProps {
  isOpen: boolean;
  onClose: () => void;
  exercise: IGrammarExercise;
  userAnswers: IUserAnswers;
}

const PotExerciseResultModal: FC<PotExerciseResultModalProps> = ({
  isOpen,
  onClose,
  exercise,
  userAnswers,
}) => {
  const [pdfPreview, setPdfPreview] = useState<string | null>(null);
  const exerciseResults = JSON.parse(
    exercise?.pivot?.correction || "[]",
  ) as IScoreBar[];
  const uniqueExerciseResults = uniqBy(exerciseResults, "type");

  const generatePdfPreview = async () => {
    try {
      const pdfDoc = generatePDF(exercise, uniqueExerciseResults, userAnswers);
      const pdfData = pdfDoc.output("datauristring");
      setPdfPreview(pdfData);
    } catch (error) {
      console.error("Error generating PDF preview:", error);
    }
  };

  useEffect(() => {
    if (isOpen) {
      void generatePdfPreview();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const handleDownloadClick = () => {
    try {
      const pdfDoc = generatePDF(exercise, uniqueExerciseResults, userAnswers);
      pdfDoc.save(`${exercise?.name || "Exercise"}_Results.pdf`);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  return (
    <CustomModal
      isOpen={isOpen}
      onClose={onClose}
      showCloseButton={false}
      className="max-w-[80vw]"
    >
      <div className="bg-white rounded-lg shadow-lg overflow-hidden">
        <div className="bg-[#8065C9] p-4">
          <h2 className="text-white text-xl">Exercise Review</h2>
        </div>

        <div className="p-6 flex flex-col gap-6 bg-[#F8F5FF]">
          <div className="h-[600px] bg-white rounded-lg">
            {pdfPreview ? (
              <PDFViewer fileBase64={pdfPreview} fileUrl={pdfPreview} />
            ) : (
              <div className="flex items-center justify-center h-full">
                <Spinner className="!h-12 !w-12 border-t-light" />
              </div>
            )}
          </div>

          <div className="flex flex-col lg:flex-row gap-4">
            <Button
              variant="outline"
              onClick={handleDownloadClick}
              className="flex-1 border-[#8065C9] text-[#8065C9] hover:bg-[#8065C9] hover:text-white"
            >
              Download answers
            </Button>

            <Button
              onClick={onClose}
              className="flex-1 bg-[#8065C9] text-white hover:bg-[#6A4FB8]"
            >
              Close
            </Button>
          </div>
        </div>
      </div>
    </CustomModal>
  );
};

export default PotExerciseResultModal;
